export default __webpack_public_path__ + "static/media/19.57f4091d.jpg";